import AuthService from './AuthService';

// Read-facing help-center service: returns only content visible to the
// current viewer (filtered server-side by plan features).
class HelpService {
    constructor() {
        const rawBaseUrl = process.env.REACT_APP_CHATBOT_API_URL || process.env.CHATBOT_API_URL || '';
        this.apiBaseUrl = rawBaseUrl.replace(/\/+$/, '');
        this.helpPath = '/private/help';
    }

    getAuthHeaders(extraHeaders) {
        const token = AuthService.getAccessToken();
        const authHeader = token ? { Authorization: `Bearer ${token}` } : {};
        return {
            ...authHeader,
            ...(extraHeaders || {}),
        };
    }

    async getVisibleArticles(loginAs) {
        const loginAsParam = loginAs ? `?loginAs=${encodeURIComponent(loginAs)}` : '';
        const url = `${this.apiBaseUrl}${this.helpPath}${loginAsParam}`;
        const response = await fetch(url, {
            method: 'GET',
            headers: this.getAuthHeaders(),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return Array.isArray(data) ? data : [];
    }

    async getArticlesForAnchor(anchorKey, loginAs) {
        if (!anchorKey) return [];
        const loginAsParam = loginAs ? `?loginAs=${encodeURIComponent(loginAs)}` : '';
        const url = `${this.apiBaseUrl}${this.helpPath}/anchor/${encodeURIComponent(anchorKey)}${loginAsParam}`;
        const response = await fetch(url, {
            method: 'GET',
            headers: this.getAuthHeaders(),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return Array.isArray(data) ? data : [];
    }
}

const helpService = new HelpService();
export { HelpService };
export default helpService;
